<template>
  <section
    class="introduction"
    :class="{ 'introduction--vertical-spacing': verticalSpacing }"
  >
    <header class="introduction__header">
      <headline class="introduction__title">
        {{ title }}
        <small v-if="subtitle">{{ subtitle }}</small>
      </headline>
    </header>
    <div
      v-if="$slots.default"
      class="introduction__content"
    >
      <slot />
    </div>
  </section>
</template>

<script>
import headline from './headline.vue'

export default {
  name: 'CIntroduction',

  components: {
    headline
  },

  props: {
    title: {
      type: String,
      required: true
    },
    subtitle: {
      type: String,
      default: undefined
    },
    verticalSpacing: Boolean
  }
}
</script>

<style lang="scss">
@import "../css/variables";
@import "../css/mixins";

.introduction {
  padding: $gutter-sm;
  background-color: #fff;

  @media (min-width: $breakpoint-md) {
    padding: $gutter-md;
  }
}

.introduction--vertical-spacing {
  @include vertical-spacing;
}

.introduction__content {
  margin-top: $gutter-sm;

  @media (min-width: $breakpoint-md) {
    margin-top: $gutter-md;
  }

  > :first-child {
    margin-top: 0;
  }

  > :last-child {
    margin-bottom: 0;
  }
}
</style>
